// Working title lives in one constant so it can be renamed later (RALLY_GOAL.md §0).
export const GAME_TITLE = 'Loose Surface';
export const GAME_TAGLINE = 'Forest rally special stage';
export const SETTINGS_KEY = 'loose-surface.settings';
export const SETTINGS_VERSION = 2;
export const BEST_TIMES_KEY = 'loose-surface.best';
export const GHOST_KEY = 'loose-surface.ghost';
